export default "__VITE_ASSET__26667a66__"